import axios from '../../service/index'
import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import E from 'wangeditor'
import { Button, Divider, Table, Modal, message, Form, Input, Pagination, Icon, Switch } from 'antd'
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
import {component} from "../../commponents/tableRow"

import './zipPackage.less'

class ZipDetail extends Component {
  state = {
    showKnowName: false,
    modelTitle: '新增资料包',
    username: 'fjs',
    packagefile: '',
    num: '',
    introduce: '',
    presetNum: '',
    fileList: [],
    editor: '',
    iconLoading: false,
    columns: [{
      title: '资料包名称',
      dataIndex: 'datumName',
      align: 'left',
      key: 'datumName',
    },
    {
      title: '需要助力人数',
      dataIndex: 'helpPeople',
      align: 'center',
      key: 'helpPeople'
    },{
      title: () => { return <div className="detail-flex-header">
        已领取用户数 
        <div>
          <Icon type="caret-up" style={{color: this.state.sortnum === 1?'#277fff':''}} className="icon-css" onClick={() => {this.sortListHandle(1)}}></Icon>
          <Icon type="caret-down" style={{color: this.state.sortnum === 2?'#277fff':''}} className="icon-css" onClick={() => {this.sortListHandle(2)}}></Icon>
          </div>
        </div>},
      dataIndex: 'gainPeople',
      align: 'center',
      key: 'gainPeople'
    },
	{
		title: '是否new标识',
		dataIndex: 'isNew',
		key: 'isNew',
		align: 'center',
		render: (record,text) => {
			return (
				<div>
					<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
						 let id = text.id
						 let arr = this.state.dataSource
						for(let i = 0; i<arr.length; i++){
							if(id === arr[i].id){
								arr[i].isNew = checked===true? 1: 0
								this.setState({
									dataSource: arr
								})
							}
						}
						return (
							Modal.confirm({
								title: `${checked === true ? '增加标识' : '取消标识'}`,
								okText: "确定",
								cancelText: "取消",
								content: (
									<div>
										<p>{checked === true ? '打开后将在该资料包添加new标识' : '关闭后将在该资料包取消new标识？'}</p>
									</div>
								),
								onOk: () => {
									this.isRelease(id,checked,'ok')
								},
								onCancel: () => {
									this.isRelease(id,checked,'cancel')
								}
							})
						)
					}} />

				</div>
			)
		}
	},
	{
      title: '操作',
      align: 'center',
      width: '200px',
      render: (row) => {
        return (
          <div className="all-btn">
            <Button type="link" onClick={() => {this.handleKnow('edit',row)}}>编辑</Button>
            <Button type="link" className="red-color" onClick={() => {
              Modal.confirm({
								title: '删除',
								okText: "确认",
								cancelText: "取消",
								content: '删除后将不可恢复，请谨慎操作！确定要删除吗？',
								onOk: () => {
									this.delStage(row.id)
								},
							});
            }}>删除</Button>
          </div>
        )
      }
    }],
    notChanged: [],
    dataSource: [],
    subjectId: '',
    subjectName: '',
    datumName: '',
    total: 0,
    pageNum:1,
    size: 10,
    sortnum: ''
  }
  componentDidMount() {
    let {subjectId, subjectName} = this.props.location.state
    this.setState({subjectId,  subjectName},() => {
      this.InitPackageList()
    })
  }
  InitPackageList() {
    let {datumName, pageNum,subjectId, size, sortnum } = this.state
    axios.post('datum/list', {datumName,pageNum,subjectId, pageSize: size, sort: sortnum}).then(res => {
      if (res.data.code === '200') {
        this.setState({total: res.data.data.total, notChanged: res.data.data.list, dataSource: res.data.data.list})
      }
    })
  }
  pageChange = (current) => {
    this.setState({pageNum: current},() => {
      this.InitPackageList()
    })
  }
  sizeChange = (current, pageSize) => {
    this.setState({size: pageSize},() => {
      this.InitPackageList()
    })
  }
  sortListHandle(num) {
    this.setState({sortnum: num},() => {
      this.InitPackageList()
    })
  }
  moveRow = (dragIndex, hoverIndex) => {
    let {dataSource} = this.state
    const dragRow = dataSource[dragIndex];
    this.setState(
			update(this.state, {
				dataSource: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
    let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id })
		}
    axios.post('/datum/update/sort',oldSort).then(res => {
			if(res.data.code === '200' ){
        oldSort = []
      }
		})
  }
  delStage(id) {
    axios.get(`/datum/delete/${id}`).then(res => {
      if(res.data.code !== '200')return message.error(res.data.msg)
      message.success('删除成功')
      this.InitPackageList()
    })
  }
  powerValidateForm = (rule, value, callback) => {
    let reg = /^([0]|[1-9][0-9]*)$/
    if(!reg.test(value)) {
      callback('请输入正整数')
    }else if(value<1||value>10){
      callback('请输入大于等于1小于10的正整数')
    }else{
      callback()
    }
  }
  presetValidateForm = (rule, value, callback) => {
    let reg = /^([0]|[1-9][0-9]*)$/
    if(!reg.test(value)) {
      callback('请输入正整数')
    }else if(value<1){
      callback('请输入大于等于1的正整数')
    }else{
      callback()
    }
  }
  submitOk() {
    this.props.form.validateFields((err, values) => {
      if(!err) {
        this.props.form.resetFields();
      }
    })
  }
  handleKnow(name, obj) {
    let {subjectId, subjectName} = this.state
    this.props.history.push('/pack',{typeTitel: name,zipId: obj.id, subjectId, subjectName})

  }
  richText = () => {
    setTimeout(() => {
      if(this.state.editor) return false
      let editor = new E(ReactDOM.findDOMNode(this._div))
      editor.config.menus = [
        	'head',
        	'bold',
        	'fontSize',
        	'fontName',
        	'italic',
        	'underline',
        	'strikeThrough',
        	'indent',
        	'lineHeight',
        	'foreColor',
        	'backColor',
        	'link',
        	'list',
        	'todo',
        	'justify',
        	'quote',
        	'table',
        	'splitLine',
        	'undo',
        	'redo',
        	'image',
        ]
      editor.config.uploadImgMaxLength = 5;
      editor.config.showLinkImg = false;
      editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
      editor.config.withCredentials = false;
      editor.config.uploadImgTimeout = 5 * 1000;
		// editor.customConfig.zIndex = 100;
    editor.create()
    editor.config.onchange = (html) => {
      this.setState({
        introduce: html
      })
      this.props.form.setFieldsValue({
				'introduce': html
			});
    }
    },500)
    
  }
  normFile = e => {
		if (e.fileList.length === 2) {
			e.fileList = e.fileList.slice(-1);
			message.warning("一个版本只能上传一个文件")
		};
		if (Array.isArray(e)) {
			return e;
		}
		return e && e.fileList;
	};
  handleChangefile = ({file, fileList}) => {
    if (file.percent === 100) {
      if (file.status === 'done') {
        let namefile = file.file.name
        console.log(namefile)
      }
    }
  }
  isRelease = (id,checked,type) => {
    if(type === 'cancel'){
      this.InitPackageList()
    }else {
      axios.post('datum/update',{
        id: id,
        isNew: checked === true ? 1 : 0
      }).then(res => {
        if(res.data.code === '200') {
          message.success(`${checked === true ? '增加最新标识' : '取消最新标识'}`)
          this.InitPackageList()
          Modal.destroyAll();
        }else {
          message.error(res.data.msg)
        }
      })
    }
  }
  render() {
    let {dataSource, columns,total, pageNum, subjectName} = this.state
    // const { getFieldDecorator } = this.props.form;
    
    return (
      <div className="detail">
        <div className="header-between">
          <span className="header-name">{subjectName}资料包</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/datum')
            }}>返回上一级</span>
          </div>
				<Divider />
          <div className="search-center">
            <Input value={this.state.datumName} placeholder="搜索资料包名称" onChange={(e) => {this.setState({datumName: e.target.value})}} />
            <Button className='my-button-primary' type='primary' onClick={() => {
                this.InitPackageList()
            }}>搜索</Button>
            <Button className="zip-left" onClick={() => {
              this.setState({datumName: ''},() => {
                  this.InitPackageList()
               })}}>重置</Button>
            <Button className='my-button-primary rig-btn' type='primary' onClick={() => {
                this.handleKnow('add',{})
            }}>新增资料包</Button>
          </div>
          <DndProvider backend={HTML5Backend}>
            <Table dataSource={dataSource} columns={columns} rowKey={record => record.id} pagination={false} components={component} 
            onRow={(record, index) => ({
                index,
                moveRow: this.moveRow,
              })} />
              <Pagination className="table-pagination" total={total} current={pageNum} showSizeChanger showQuickJumper pageSizeOptions={['10','20','50','100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} />
          </DndProvider>
          {/* <Modal title={modelTitle} width="60%" visible={showKnowName} onOk={() => {this.submitOk()}} onCancel={() => {this.setState({showKnowName: false})}}>
          <Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.submitOk}>
						<Form.Item label="资料包名称" name="username">
              {getFieldDecorator('username', {
              rules: [
                {required: true,message: '请输入资料包名称'},
                {max: 20,message: '最多输入20个字!'}
              ],
              initialValue: modelTitle == '编辑资料包'?username:''
            })(<Input />)}
						</Form.Item>
            <Form.Item label="资料包文件" name="packagefile">
              {getFieldDecorator('packagefile', {
              rules: [
                {required: true,message: '请输入资料包名称'}
              ],
              valuePropName: 'filelist',
							getValueFromEvent: this.normFile,
            })(
              <div className="file-css">
                <Upload
                  accept=".doc, .docx, .xls, .xlsx, .png, .jpg,  .ppt, .pptx, .pdf, .zip, .rar, .7z"
                  listType='picture'
                  showUploadList={false}
                  beforeUpload={(file, filelist) => {
                    const isLt10M = file.size / 1024 / 1024/1024 <= 1;
                    if (!isLt10M) {
                      return	message.error("文件大小限制在1G以下！");
                    }
                  }}
                  onChange={this.handleChangefile}
                  >
                    <Button type="primary" loading={iconLoading} className="my-button-primary">选择文件</Button>
                  {this.state.fileList.length >= 1 ? '' : uploadButton}
                </Upload>
                <p style={{margin:0,height: "20px",color: '#ccc'}}>1.支持.doc, .docx, .xls, .xlsx, .png, .jpg,  .ppt, .pptx, .pdf, .zip, .rar, .7z格式，大小不超过1GB</p>
                <p style={{margin:0,height: "20px",color: '#ccc'}}>2.只能上传一个文件</p>
              </div>
            )}
						</Form.Item>
            <Form.Item label="所需助力人数" name="num">
              {getFieldDecorator('num', {
              rules: [
                {required: true, message: '请输入所需助力人数'},
                { validator: this.powerValidateForm }
              ],
              initialValue: modelTitle == '编辑资料包'?num:''
            })(<Input />)}
						</Form.Item>
            <Form.Item label="预设领取资料人数" name="presetNum">
              {getFieldDecorator('presetNum', {
              rules: [
                { validator: this.presetValidateForm }
              ],
              initialValue: modelTitle == '编辑资料包'?presetNum:''
            })(<Input />)}
						</Form.Item>
            <Form.Item label="资料包详情">
              {getFieldDecorator('introduce', {
              initialValue: modelTitle == '编辑资料包'?introduce:''
            })(
              // <div className="editor-height" id='div1'></div>
							<div ref={(ref) => this._div = ref}></div>
						)}
						</Form.Item>
					</Form>
          </Modal> */}
      </div>
    )
  }
}
export default Form.create()(ZipDetail)